/*
  N de Nube - scripts propios (cargado por snippets/theme-globals.liquid con useCustomEvents = true).

  Filtros de coleccion: solo un grupo abierto a la vez.
  El tema abre/cierra cada grupo con su propio JS al pulsar [data-drawer-group-toggle]; aqui, justo despues
  de que el tema haya abierto el grupo pulsado, cerramos el resto de grupos abiertos del mismo panel
  pulsandolos de forma programatica (asi el tema mantiene su estado interno).
*/
(function () {
  var closing = false;

  document.addEventListener(
    'click',
    function (event) {
      if (closing) return;
      var toggle = event.target && event.target.closest ? event.target.closest('[data-drawer-group-toggle]') : null;
      if (!toggle) return;

      var panel =
        toggle.closest('[data-filter-sidebar]') ||
        toggle.closest('.filter-drawer') ||
        toggle.closest('.mobile-filters') ||
        toggle.closest('[data-filter-bar]') ||
        document;

      window.setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') !== 'true') return;
        closing = true;
        try {
          panel.querySelectorAll('[data-drawer-group-toggle][aria-expanded="true"]').forEach(function (other) {
            if (other !== toggle) other.click();
          });
        } finally {
          closing = false;
        }
      }, 0);
    },
    true
  );
})();

/*
  Modal "Añadido al carrito" (N de Nube).
  El tema abre .purchase-confirmation-popup y lo cierra solo a los 5 s (o al salir el raton del panel).
  Aqui: 1) se anula el cierre automatico, 2) se bloquea el scroll de fondo mientras esta abierto,
  3) se cierra con la capa oscura o con Escape.
*/
(function () {
  var popup = document.querySelector('[data-purchase-confirmation-popup]');
  var container = popup && popup.querySelector('[js-purchase-confirmation-container]');
  if (!popup || !container) return;

  // 1) el tema registra un 'mouseleave' (una sola vez) que cierra el panel; lo anulamos antes de que llegue
  container.addEventListener('mouseleave', function (e) { e.stopImmediatePropagation(); }, true);

  function closePopup() {
    var btn = popup.querySelector('[data-confirmation-close]');
    if (btn) btn.click();
  }
  // 3) cerrar al pulsar la capa oscura (fuera del panel) o Escape
  popup.addEventListener('click', function (e) {
    if (!container.contains(e.target)) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('active')) closePopup();
  });

  // 1) + 2) al activarse el panel
  var wasActive = false;
  new MutationObserver(function () {
    var active = popup.classList.contains('active');
    if (active && !wasActive) {
      container.dispatchEvent(new Event('mouseover'));   // el tema cancela su temporizador de 5 s en el primer mouseover
      document.documentElement.classList.add('nn-popup-open');
    } else if (!active && wasActive) {
      document.documentElement.classList.remove('nn-popup-open');
    }
    wasActive = active;
  }).observe(popup, { attributes: true, attributeFilter: ['class'] });
})();

/*
  Buscador: al pulsar Intro (o la lupa) NO se va a la pagina /search; los resultados ya se ven en el panel
  (el tema los pide al escribir). Peticion del cliente.
*/
(function () {
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target && event.target.closest ? event.target.closest('[data-quick-search-form]') : null;
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      var input = form.querySelector('.quick-search__input');
      if (input) {
        input.focus();
        if (input.value.trim()) input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    },
    true
  );
})();

/* N de Nube: codigo de descuento en el carrito (snippets/cart-discount-code.liquid).
   Aplica/quita codigos con la Cart AJAX API y recarga la pagina cuando Shopify lo acepta. */
(function () {
  function postDiscount(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }
  function currentCodes(wrap) {
    return Array.prototype.map.call(wrap.querySelectorAll('[data-nn-discount-remove]'), function (b) {
      return b.getAttribute('data-nn-discount-remove');
    });
  }
  document.addEventListener('click', function (event) {
    var apply = event.target.closest ? event.target.closest('[data-nn-discount-apply]') : null;
    var remove = event.target.closest ? event.target.closest('[data-nn-discount-remove]') : null;
    if (!apply && !remove) return;
    var wrap = event.target.closest('[data-nn-discount]');
    var input = wrap.querySelector('[data-nn-discount-input]');
    var msg = wrap.querySelector('[data-nn-discount-message]');
    var existing = currentCodes(wrap);
    var code = '';
    var codes;
    if (apply) {
      code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      codes = existing.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat([code]);
      apply.disabled = true;
    } else {
      var rm = remove.getAttribute('data-nn-discount-remove');
      codes = existing.filter(function (c) { return c !== rm; });
    }
    msg.hidden = true;
    postDiscount(codes).then(function (cart) {
      var list = cart.discount_codes || [];
      if (apply) {
        var found = list.filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (!found || !found.applicable) {
          msg.textContent = wrap.getAttribute('data-invalid-text');
          msg.hidden = false;
          apply.disabled = false;
          return postDiscount(existing); // deja el carrito como estaba
        }
      }
      window.location.reload();
    }).catch(function () {
      msg.textContent = wrap.getAttribute('data-error-text');
      msg.hidden = false;
      if (apply) apply.disabled = false;
    });
  });
  // Codigos ya aplicados (con boton para quitarlos): se leen de /cart.js al cargar la pagina
  function renderCodes(wrap, codes) {
    var box = wrap.querySelector('[data-nn-discount-codes]');
    if (!box) return;
    if (!codes || !codes.length) { box.innerHTML = ''; return; }
    var removeLabel = box.getAttribute('data-remove-label') || '';
    var inapplicable = box.getAttribute('data-inapplicable-label') || '';
    var esc = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    box.innerHTML = '<ul class="nn-cart__discount-codes fs-body-75">' + codes.map(function (d) {
      return '<li class="nn-cart__discount-code' + (d.applicable ? '' : ' nn-cart__discount-code--inapplicable') + '"><span>' + esc(d.code) + (d.applicable ? '' : ' · ' + esc(inapplicable)) + '</span>' +
        '<button type="button" class="nn-cart__discount-remove" data-nn-discount-remove="' + esc(d.code) + '" aria-label="' + esc(removeLabel) + '">&times;</button></li>';
    }).join('') + '</ul>';
  }
  function loadCodes() {
    var wrap = document.querySelector('[data-nn-discount]');
    if (!wrap) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCodes(wrap, cart.discount_codes || []);
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadCodes); else loadCodes();

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches || !event.target.matches('[data-nn-discount-input]')) return;
    event.preventDefault();
    var button = event.target.closest('[data-nn-discount]').querySelector('[data-nn-discount-apply]');
    if (button) button.click();
  });
})();

/* N de Nube: "¿Tienes un cupón?" (barra fija del carrito en movil): baja hasta el campo del codigo y lo enfoca */
document.addEventListener('click', function (event) {
  var link = event.target.closest ? event.target.closest('[data-nn-coupon-link]') : null;
  if (!link) return;
  var input = document.querySelector('[data-nn-discount-input]');
  if (!input) return;
  event.preventDefault();
  input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
});

/* N de Nube: banner de coleccion - "Ver mas / Ver menos" en la descripcion recortada a 3 lineas */
(function () {
  function init() {
    document.querySelectorAll('[data-nn-banner-desc]').forEach(function (desc) {
      var btn = desc.parentElement.querySelector('[data-nn-banner-more]');
      if (!btn) return;
      var overflows = desc.scrollHeight > desc.clientHeight + 2;
      btn.hidden = !overflows && !desc.classList.contains('is-open');
    });
  }
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-nn-banner-more]') : null;
    if (!btn) return;
    var desc = btn.parentElement.querySelector('[data-nn-banner-desc]');
    var open = desc.classList.toggle('is-open');
    btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', init);
})();
